module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid17_800x653.16ae382.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid17_800x653.jpg
// module id = SQzQ
// module chunks = 0